<template>
  <div v-if="tiptap">
    <b-form-group
      v-if="hasCommand('setParagraph') && hasCommand('toggleHeading') || hasCommand('setMark')"
      label="Tag"
    >
      <v-select
        v-model="tagMutation"
        :options="tagOptions"
        :reduce="item => item.value"
        :searchable="false"
      />
    </b-form-group>
    
    <b-form-group
      v-if="hasCommand('setFontFamily') || hasCommand('setMark')"
      label="Font Family"
    >
      <v-select
        v-model="fontFamilyMutation"
        :options="fontsFamilyOptions"
        placeholder="Global Style"
      >
        <template #selected-option="{label}">
          <div
            :style="{fontFamily: label === '' ? 'Proxima Nova' : label}"
            v-text="label"
          />
        </template>

        <template #option="{label}">
          <div
            :style="{fontFamily: label}"
            v-text="label || 'Global Style'"
          />
        </template>
      </v-select>

      <div class="flex justify-start pt-2">
        <span
          class="text-[13px] text-[#44474A] hover:opacity-80 cursor-pointer underline"
          @click="unsetFontFamily"
        >
          Reset
        </span>
      </div>
    </b-form-group>
    
    <b-form-group
      v-if="hasCommand('setFontWeight') || hasCommand('setMark')"
      label="Font Weight"
    >
      <v-select
        v-model="fontWeightMutation"
        :options="fontWeightOptions"
        :reduce="item => item.value"
        :searchable="false"
        placeholder="Global Style"
      />

      <div class="flex justify-start pt-2">
        <span
          class="text-[13px] text-[#44474A] hover:opacity-80 cursor-pointer underline"
          @click="unsetFontWeight"
        >
          Reset
        </span>
      </div>
    </b-form-group>

    <range-slider
      v-if="hasCommand('setFontSize') || hasCommand('setMark')"
      v-model="fontSizeMutation"
      :unit="fontSizeUnit"
      label="Font Size"
      :default-dimension="fontSizeDefaultUnit"
      :min="{ px: 8, rem: 0.5 }"
      :max="{ px: 96, rem: 6 }"
      :step="{ px: 1, rem: 0.1 }"
      :dimensions="fontSizeUnits"
      @update:unit="applyFontSizeUnit"
      @reset="unsetFontSize"
    />

    <range-slider
      v-if="hasCommand('setLetterSpacing') || hasCommand('setMark')"
      v-model="letterSpacingMutation"
      :unit="letterSpacingUnit"
      label="Letter-Spacing"
      :default-dimension="letterSpacingDefaultUnit"
      :step="{ px: 0.25, em: 0.01 }"
      :min="{ px: -3, em: -0.1 }"
      :max="{ px: 10, em: 0.3 }"
      :dimensions="letterSpacingUnits"
      @update:unit="applyLetterSpacingUnit"
      @reset="unsetLetterSpacing"
    />

    <range-slider
      v-if="hasCommand('setLineHeight') || hasCommand('setMark')"
      v-model="lineHeightMutation"
      :unit="lineHeightUnit"
      label="Line-Height"
      :default-dimension="lineHeightDefaultUnit"
      :min="{ px: 12, em: 0.8, '%': 80 }"
      :max="{ px: 80, em: 3, '%': 250 }"
      :step="{ px: 1, em: 0.05, '%': 5 }"
      :dimensions="lineHeightUnits"
      @update:unit="applyLineHeightUnit"
      @reset="unsetLineHeight"
    />

    <div
      v-click-outside="onClickOutsideTextColorPicker"
      class="position-relative"
    >
      <color-picker-flat
        v-if="typeColor"
        ref="colorMenuFlat"
        :color="textColorMutation"
        @input="applyTextColor"
      />
    </div>

    <b-form-group>
      <background-type
        :value="textColorTypeMutation"
        :config="colorType"
        label="Color Type"
        @updated="val => applyTextColorType(val.value)"
      />
      
      <div
        v-if="!colorType.backgroundType"
        class="flex justify-end"
      >
        <color-picker-placeholder
          ref="colorPickerInvoker"
          class="mr-2"
          :color="textColorMutation"
          @click.native="() => typeColor = !typeColor"
        />

        <span
          class="mt-2 block text-[#333333] underline text-[13px] cursor-pointer hover:opacity-80 line-height-[13px]"
          @click="unsetTextColor"
        >
          Reset color
        </span>
      </div>

      <gradient-background
        v-else
        :config="backgroundGradient"
        direction-enabled
        @change="applyTextColor"
      />
    </b-form-group>

    <div
      v-click-outside="onClickOutsideBgColorPicker"
      class="position-relative"
    >
      <color-picker-flat
        v-if="typeBGColor"
        ref="bgColorMenuFlat"
        :color="backgroundColorMutation"
        class="!top-[32px]"
        @input="applyBgColor"
      />
    </div>

    <b-form-group>
      <background-type
        :value="bgColorTypeMutation"
        :config="bgColorType"
        label="Background Color Type"
        @updated="val => applyBgColorType(val.value)"
      />

      <div
        v-if="!bgColorType.backgroundType"
        class="flex justify-end"
      >
        <color-picker-placeholder
          ref="bgColorPickerInvoker"
          class="mr-2"
          :color="backgroundColorMutation"
          @click.native="() => typeBGColor = !typeBGColor"
        />

        <span
          class="mt-2 block text-[#333333] underline text-[13px] cursor-pointer hover:opacity-80 line-height-[13px]"
          @click="unsetBgColor"
        >
          Reset color
        </span>
      </div>

      <gradient-background
        v-else
        :config="bgBackgroundGradient"
        direction-enabled
        @change="applyBgColor"
      />
    </b-form-group>
    
    <!--    <b-form-group label="Rich Text">-->
    <!--      <div class="flex items-center btn-group flex-wrap gap-2">-->
    <!--        &lt;!&ndash; Text color &ndash;&gt;-->
    <!--        <div-->
    <!--          v-if="hasCommand('setColor') || hasCommand('setMark')"-->
    <!--          class="flex items-center gap-1"-->
    <!--        >-->
    <!--          <span class="text-[12px] font-[600] text-[#44474A]">A</span>-->
    <!--          <input-->
    <!--            type="color"-->
    <!--            class="h-[29px] w-[36px] border rounded-[4px] p-0"-->
    <!--            :value="textColor"-->
    <!--            @input="applyTextColor($event.target.value)"-->
    <!--          >-->
    <!--          <button-->
    <!--            v-if="hasCommand('unsetColor') || hasCommand('unsetMark')"-->
    <!--            type="button"-->
    <!--            class="btn flex justify-center !transition items-center h-[29px] !px-[10px] py-0 text-[12px] !font-[600] border rounded-[4px] !text-[#44474A] hover:!bg-[#F2F4F5]"-->
    <!--            @click="unsetTextColor"-->
    <!--          >-->
    <!--            Reset-->
    <!--          </button>-->
    <!--        </div>-->

    <!--        &lt;!&ndash; Background color &ndash;&gt;-->
    <!--        <div-->
    <!--          v-if="hasCommand('setBackgroundColor') || hasCommand('setMark')"-->
    <!--          class="flex items-center gap-1"-->
    <!--        >-->
    <!--          <span class="text-[12px] font-[600] text-[#44474A]">Bg</span>-->
    <!--          <input-->
    <!--            type="color"-->
    <!--            class="h-[29px] w-[36px] border rounded-[4px] p-0"-->
    <!--            :value="bgColor"-->
    <!--            @input="setBgColor($event.target.value)"-->
    <!--          >-->
    <!--          <button-->
    <!--            v-if="hasCommand('unsetBackgroundColor') || hasCommand('unsetMark')"-->
    <!--            type="button"-->
    <!--            class="btn flex justify-center !transition items-center h-[29px] !px-[10px] py-0 text-[12px] !font-[600] border rounded-[4px] !text-[#44474A] hover:!bg-[#F2F4F5]"-->
    <!--            @click="unsetBgColor"-->
    <!--          >-->
    <!--            Reset-->
    <!--          </button>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </b-form-group>-->

    <b-form-group label="Text Alignment">
      <b-btn-group>
        <b-btn
          v-if="hasCommand('setTextAlign')"
          v-b-tooltip
          title="Left"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().setTextAlign('left').run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': activeTextAlign !== 'left' }"
          >
            <path d="M384 128C384 145.7 369.7 160 352 160L128 160C110.3 160 96 145.7 96 128C96 110.3 110.3 96 128 96L352 96C369.7 96 384 110.3 384 128zM384 384C384 401.7 369.7 416 352 416L128 416C110.3 416 96 401.7 96 384C96 366.3 110.3 352 128 352L352 352C369.7 352 384 366.3 384 384zM96 256C96 238.3 110.3 224 128 224L512 224C529.7 224 544 238.3 544 256C544 273.7 529.7 288 512 288L128 288C110.3 288 96 273.7 96 256zM544 512C544 529.7 529.7 544 512 544L128 544C110.3 544 96 529.7 96 512C96 494.3 110.3 480 128 480L512 480C529.7 480 544 494.3 544 512z" />
          </svg>
        </b-btn>
        <b-btn
          v-if="hasCommand('setTextAlign')"
          v-b-tooltip
          title="Center"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().setTextAlign('center').run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': activeTextAlign !== 'center' }"
          >
            <path d="M448 128C448 110.3 433.7 96 416 96L224 96C206.3 96 192 110.3 192 128C192 145.7 206.3 160 224 160L416 160C433.7 160 448 145.7 448 128zM544 256C544 238.3 529.7 224 512 224L128 224C110.3 224 96 238.3 96 256C96 273.7 110.3 288 128 288L512 288C529.7 288 544 273.7 544 256zM96 512C96 529.7 110.3 544 128 544L512 544C529.7 544 544 529.7 544 512C544 494.3 529.7 480 512 480L128 480C110.3 480 96 494.3 96 512zM448 384C448 366.3 433.7 352 416 352L224 352C206.3 352 192 366.3 192 384C192 401.7 206.3 416 224 416L416 416C433.7 416 448 401.7 448 384z" />
          </svg>
        </b-btn>
        <b-btn
          v-if="hasCommand('setTextAlign')"
          v-b-tooltip
          title="Right"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().setTextAlign('right').run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': activeTextAlign !== 'right' }"
          >
            <path d="M544 128C544 145.7 529.7 160 512 160L288 160C270.3 160 256 145.7 256 128C256 110.3 270.3 96 288 96L512 96C529.7 96 544 110.3 544 128zM544 384C544 401.7 529.7 416 512 416L288 416C270.3 416 256 401.7 256 384C256 366.3 270.3 352 288 352L512 352C529.7 352 544 366.3 544 384zM96 256C96 238.3 110.3 224 128 224L512 224C529.7 224 544 238.3 544 256C544 273.7 529.7 288 512 288L128 288C110.3 288 96 273.7 96 256zM544 512C544 529.7 529.7 544 512 544L128 544C110.3 544 96 529.7 96 512C96 494.3 110.3 480 128 480L512 480C529.7 480 544 494.3 544 512z" />
          </svg>
        </b-btn>
        <b-btn
          v-if="hasCommand('setTextAlign')"
          v-b-tooltip
          title="Justify"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().setTextAlign('justify').run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': activeTextAlign !== 'justify' }"
          >
            <path d="M544 128C544 110.3 529.7 96 512 96L128 96C110.3 96 96 110.3 96 128C96 145.7 110.3 160 128 160L512 160C529.7 160 544 145.7 544 128zM544 384C544 366.3 529.7 352 512 352L128 352C110.3 352 96 366.3 96 384C96 401.7 110.3 416 128 416L512 416C529.7 416 544 401.7 544 384zM96 256C96 273.7 110.3 288 128 288L512 288C529.7 288 544 273.7 544 256C544 238.3 529.7 224 512 224L128 224C110.3 224 96 238.3 96 256zM544 512C544 494.3 529.7 480 512 480L128 480C110.3 480 96 494.3 96 512C96 529.7 110.3 544 128 544L512 544C529.7 544 544 529.7 544 512z" />
          </svg>
        </b-btn>
      </b-btn-group>
    </b-form-group>
    
    <b-form-group
      v-if="(hasCommand('indent') || hasCommand('setIndent')) && !isInTable"
    >
      <b-btn-group>
        <b-btn
          v-b-tooltip
          title="Outdent"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="outdentText"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="w-4 h-4"
            :class="{ 'opacity-40': indentLevel <= 0 }"
          >
            <path d="M21 5H11" />
            <path d="M21 12H11" />
            <path d="M21 19H11" />
            <path d="m7 8-4 4 4 4" />
          </svg>
        </b-btn>

        <b-btn
          v-b-tooltip
          title="Indent"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="indentText"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="w-4 h-4"
            :class="{ 'opacity-40': indentLevel === 8 }"
          >
            <path d="M21 5H11" />
            <path d="M21 12H11" />
            <path d="M21 19H11" />
            <path d="m3 8 4 4-4 4" />
          </svg>
        </b-btn>
      </b-btn-group>
    </b-form-group>

    <b-form-group label="Text Vertical Alignment">
      <b-btn-group>
        <b-btn
          v-if="hasCommand('toggleSubscript')"
          v-b-tooltip
          title="Subscript"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().toggleSubscript().run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': !tiptap.isActive('subscript') }"
          >
            <path d="M128 128C110.3 128 96 142.3 96 160C96 177.7 110.3 192 128 192L143.3 192L232.9 320L143.3 448L128 448C110.3 448 96 462.3 96 480C96 497.7 110.3 512 128 512L160 512C170.4 512 180.2 506.9 186.2 498.4L272 375.8L357.8 498.4C363.8 507 373.6 512 384 512L416 512C433.7 512 448 497.7 448 480C448 462.3 433.7 448 416 448L400.7 448L311.1 320L400.7 192L416 192C433.7 192 448 177.7 448 160C448 142.3 433.7 128 416 128L384 128C373.6 128 363.8 133.1 357.8 141.6L272 264.2L186.2 141.6C180.2 133.1 170.4 128 160 128L128 128zM576 384C576 372.9 570.3 362.6 560.8 356.8C551.3 351 539.6 350.4 529.7 355.4L497.7 371.4C481.9 379.3 475.5 398.5 483.4 414.3C489 425.5 500.3 432 512 432L512 512C494.3 512 480 526.3 480 544C480 561.7 494.3 576 512 576L576 576C593.7 576 608 561.7 608 544C608 526.3 593.7 512 576 512L576 384z" />
          </svg>
        </b-btn>
        <b-btn
          v-if="hasCommand('toggleSuperscript')"
          v-b-tooltip
          title="Superscript"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().toggleSuperscript().run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': !tiptap.isActive('superscript') }"
          >
            <path d="M576 96C576 84.9 570.3 74.6 560.8 68.8C551.3 63 539.6 62.4 529.7 67.4L497.7 83.4C481.9 91.3 475.5 110.5 483.4 126.3C489 137.5 500.3 144 512 144L512 224C494.3 224 480 238.3 480 256C480 273.7 494.3 288 512 288L576 288C593.7 288 608 273.7 608 256C608 238.3 593.7 224 576 224L576 96zM128 128C110.3 128 96 142.3 96 160C96 177.7 110.3 192 128 192L143.3 192L232.9 320L143.3 448L128 448C110.3 448 96 462.3 96 480C96 497.7 110.3 512 128 512L160 512C170.4 512 180.2 506.9 186.2 498.4L272 375.8L357.8 498.4C363.8 507 373.6 512 384 512L416 512C433.7 512 448 497.7 448 480C448 462.3 433.7 448 416 448L400.7 448L311.1 320L400.7 192L416 192C433.7 192 448 177.7 448 160C448 142.3 433.7 128 416 128L384 128C373.6 128 363.8 133.1 357.8 141.6L272 264.2L186.2 141.6C180.2 133.1 170.4 128 160 128L128 128z" />
          </svg>
        </b-btn>
      </b-btn-group>
    </b-form-group>

    <b-form-group label="Text Decoration">
      <b-btn-group>
        <b-btn
          v-if="hasCommand('toggleBold')"
          v-b-tooltip
          title="Bold"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().toggleBold().run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': !tiptap.isActive('bold') }"
          >
            <path d="M160 96C142.3 96 128 110.3 128 128C128 145.7 142.3 160 160 160L192 160L192 480L160 480C142.3 480 128 494.3 128 512C128 529.7 142.3 544 160 544L384 544C454.7 544 512 486.7 512 416C512 369.5 487.2 328.7 450 306.3C468.7 284 480 255.3 480 224C480 153.3 422.7 96 352 96L160 96zM416 224C416 259.3 387.3 288 352 288L256 288L256 160L352 160C387.3 160 416 188.7 416 224zM256 480L256 352L384 352C419.3 352 448 380.7 448 416C448 451.3 419.3 480 384 480L256 480z" />
          </svg>
        </b-btn>
        <b-btn
          v-if="hasCommand('toggleItalic')"
          v-b-tooltip
          title="Italic"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().toggleItalic().run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': !tiptap.isActive('italic') }"
          >
            <path d="M256 128C256 110.3 270.3 96 288 96L480 96C497.7 96 512 110.3 512 128C512 145.7 497.7 160 480 160L421.3 160L288 480L352 480C369.7 480 384 494.3 384 512C384 529.7 369.7 544 352 544L160 544C142.3 544 128 529.7 128 512C128 494.3 142.3 480 160 480L218.7 480L352 160L288 160C270.3 160 256 145.7 256 128z" />
          </svg>
        </b-btn>
        <b-btn
          v-if="hasCommand('toggleUnderline')"
          v-b-tooltip
          title="Underline"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().toggleUnderline().run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': !tiptap.isActive('underline') }"
          >
            <path d="M128 96C128 78.3 142.3 64 160 64L224 64C241.7 64 256 78.3 256 96C256 113.7 241.7 128 224 128L224 288C224 341 267 384 320 384C373 384 416 341 416 288L416 128C398.3 128 384 113.7 384 96C384 78.3 398.3 64 416 64L480 64C497.7 64 512 78.3 512 96C512 113.7 497.7 128 480 128L480 288C480 376.4 408.4 448 320 448C231.6 448 160 376.4 160 288L160 128C142.3 128 128 113.7 128 96zM128 544C128 526.3 142.3 512 160 512L480 512C497.7 512 512 526.3 512 544C512 561.7 497.7 576 480 576L160 576C142.3 576 128 561.7 128 544z" />
          </svg>
        </b-btn>
        <b-btn
          v-if="hasCommand('toggleStrike')"
          v-b-tooltip
          title="Strike"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().toggleStrike().run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': !tiptap.isActive('strike') }"
          >
            <path d="M160 221.5C160 152.2 216.2 96 285.5 96L432 96C449.7 96 464 110.3 464 128C464 145.7 449.7 160 432 160L285.5 160C251.5 160 224 187.5 224 221.5C224 252.5 247.1 278.7 277.9 282.5L322 288L544 288C561.7 288 576 302.3 576 320C576 337.7 561.7 352 544 352L96 352C78.3 352 64 337.7 64 320C64 302.3 78.3 288 96 288L179.1 288C167 268.6 160 245.8 160 221.5zM413.2 400L478.7 400C479.6 406.1 480.1 412.2 480.1 418.5C480.1 487.8 423.9 544 354.6 544L208 544C190.3 544 176 529.7 176 512C176 494.3 190.3 480 208 480L354.5 480C388.5 480 416 452.5 416 418.5C416 412.1 415 405.8 413.2 400z" />
          </svg>
        </b-btn>
      </b-btn-group>
    </b-form-group>

    <b-form-group label="Lists">
      <b-btn-group>
        <b-btn
          v-if="hasCommand('toggleBulletList')"
          v-b-tooltip
          title="Bullet List"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().toggleBulletList().run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': !tiptap.isActive('bulletList') }"
          >
            <path d="M112 208C138.5 208 160 186.5 160 160C160 133.5 138.5 112 112 112C85.5 112 64 133.5 64 160C64 186.5 85.5 208 112 208zM256 128C238.3 128 224 142.3 224 160C224 177.7 238.3 192 256 192L544 192C561.7 192 576 177.7 576 160C576 142.3 561.7 128 544 128L256 128zM256 288C238.3 288 224 302.3 224 320C224 337.7 238.3 352 256 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L256 288zM256 448C238.3 448 224 462.3 224 480C224 497.7 238.3 512 256 512L544 512C561.7 512 576 497.7 576 480C576 462.3 561.7 448 544 448L256 448zM112 528C138.5 528 160 506.5 160 480C160 453.5 138.5 432 112 432C85.5 432 64 453.5 64 480C64 506.5 85.5 528 112 528zM160 320C160 293.5 138.5 272 112 272C85.5 272 64 293.5 64 320C64 346.5 85.5 368 112 368C138.5 368 160 346.5 160 320z" />
          </svg>
        </b-btn>
        <b-btn
          v-if="hasCommand('toggleOrderedList')"
          v-b-tooltip
          title="Ordered List"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().toggleOrderedList().run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': !tiptap.isActive('orderedList') }"
          >
            <path d="M64 136C64 122.8 74.7 112 88 112L136 112C149.3 112 160 122.7 160 136L160 240L184 240C197.3 240 208 250.7 208 264C208 277.3 197.3 288 184 288L88 288C74.7 288 64 277.3 64 264C64 250.7 74.7 240 88 240L112 240L112 160L88 160C74.7 160 64 149.3 64 136zM94.4 365.2C105.8 356.6 119.7 352 134 352L138.9 352C172.6 352 200 379.4 200 413.1C200 432.7 190.6 451 174.8 462.5L150.8 480L184 480C197.3 480 208 490.7 208 504C208 517.3 197.3 528 184 528L93.3 528C77.1 528 64 514.9 64 498.7C64 489.3 68.5 480.5 76.1 475L146.6 423.7C150 421.2 152 417.3 152 413.1C152 405.9 146.1 400 138.9 400L134 400C130.1 400 126.3 401.3 123.2 403.6L102.4 419.2C91.8 427.2 76.8 425 68.8 414.4C60.8 403.8 63 388.8 73.6 380.8L94.4 365.2zM288 128L544 128C561.7 128 576 142.3 576 160C576 177.7 561.7 192 544 192L288 192C270.3 192 256 177.7 256 160C256 142.3 270.3 128 288 128zM288 288L544 288C561.7 288 576 302.3 576 320C576 337.7 561.7 352 544 352L288 352C270.3 352 256 337.7 256 320C256 302.3 270.3 288 288 288zM288 448L544 448C561.7 448 576 462.3 576 480C576 497.7 561.7 512 544 512L288 512C270.3 512 256 497.7 256 480C256 462.3 270.3 448 288 448z" />
          </svg>
        </b-btn>
        <b-btn
          v-if="hasCommand('toggleTaskList')"
          v-b-tooltip
          title="Task List"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().toggleTaskList().run()"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': !tiptap.isActive('taskList') }"
          >
            <path d="M197.8 100.3C208.7 107.9 211.3 122.9 203.7 133.7L147.7 213.7C143.6 219.5 137.2 223.2 130.1 223.8C123 224.4 116 222 111 217L71 177C61.7 167.6 61.7 152.4 71 143C80.3 133.6 95.6 133.7 105 143L124.8 162.8L164.4 106.2C172 95.3 187 92.7 197.8 100.3zM197.8 260.3C208.7 267.9 211.3 282.9 203.7 293.7L147.7 373.7C143.6 379.5 137.2 383.2 130.1 383.8C123 384.4 116 382 111 377L71 337C61.6 327.6 61.6 312.4 71 303.1C80.4 293.8 95.6 293.7 104.9 303.1L124.7 322.9L164.3 266.3C171.9 255.4 186.9 252.8 197.7 260.4zM288 160C288 142.3 302.3 128 320 128L544 128C561.7 128 576 142.3 576 160C576 177.7 561.7 192 544 192L320 192C302.3 192 288 177.7 288 160zM288 320C288 302.3 302.3 288 320 288L544 288C561.7 288 576 302.3 576 320C576 337.7 561.7 352 544 352L320 352C302.3 352 288 337.7 288 320zM224 480C224 462.3 238.3 448 256 448L544 448C561.7 448 576 462.3 576 480C576 497.7 561.7 512 544 512L256 512C238.3 512 224 497.7 224 480zM128 440C150.1 440 168 457.9 168 480C168 502.1 150.1 520 128 520C105.9 520 88 502.1 88 480C88 457.9 105.9 440 128 440z" />
          </svg>
        </b-btn>
      </b-btn-group>
    </b-form-group>
    
    <!--    <b-form-group label="List Icon">-->
    <!--      <UploadAsset-->
    <!--        title="Upload Icon"-->
    <!--        type="svg"-->
    <!--        @uploaded="insertListIcon"-->
    <!--      />-->
    <!--    </b-form-group>-->

    <b-form-group label="Blocks">
      <b-btn-group>
        <b-btn
          v-if="hasCommand('toggleBlockquote')"
          v-b-tooltip
          title="Blockquote"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().toggleBlockquote().run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': !tiptap.isActive('blockquote') }"
          >
            <path d="M96 280C96 213.7 149.7 160 216 160L224 160C241.7 160 256 174.3 256 192C256 209.7 241.7 224 224 224L216 224C185.1 224 160 249.1 160 280L160 288L224 288C259.3 288 288 316.7 288 352L288 416C288 451.3 259.3 480 224 480L160 480C124.7 480 96 451.3 96 416L96 280zM352 280C352 213.7 405.7 160 472 160L480 160C497.7 160 512 174.3 512 192C512 209.7 497.7 224 480 224L472 224C441.1 224 416 249.1 416 280L416 288L480 288C515.3 288 544 316.7 544 352L544 416C544 451.3 515.3 480 480 480L416 480C380.7 480 352 451.3 352 416L352 280z" />
          </svg>
        </b-btn>
        <b-btn
          v-if="hasCommand('setImage')"
          v-b-tooltip
          title="Image"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
        >
          <UploadAsset
            title="Upload Image"
            @uploaded="insertImage"
          >
            <template #trigger>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 640"
                class="w-4 h-4"
                :class="{ 'opacity-40': !tiptap.isActive('image') }"
              >
                <path d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160C544 124.7 515.3 96 480 96L160 96zM224 176C250.5 176 272 197.5 272 224C272 250.5 250.5 272 224 272C197.5 272 176 250.5 176 224C176 197.5 197.5 176 224 176zM368 288C376.4 288 384.1 292.4 388.5 299.5L476.5 443.5C481 450.9 481.2 460.2 477 467.8C472.8 475.4 464.7 480 456 480L184 480C175.1 480 166.8 475 162.7 467.1C158.6 459.2 159.2 449.6 164.3 442.3L220.3 362.3C224.8 355.9 232.1 352.1 240 352.1C247.9 352.1 255.2 355.9 259.7 362.3L286.1 400.1L347.5 299.6C351.9 292.5 359.6 288.1 368 288.1z" />
              </svg>
            </template>
          </UploadAsset>
        </b-btn>
        <b-btn
          v-if="hasCommand('toggleCodeBlock')"
          v-b-tooltip
          title="Code Block"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().toggleCodeBlock().run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': !tiptap.isActive('codeBlock') }"
          >
            <path d="M392.8 65.2C375.8 60.3 358.1 70.2 353.2 87.2L225.2 535.2C220.3 552.2 230.2 569.9 247.2 574.8C264.2 579.7 281.9 569.8 286.8 552.8L414.8 104.8C419.7 87.8 409.8 70.1 392.8 65.2zM457.4 201.3C444.9 213.8 444.9 234.1 457.4 246.6L530.8 320L457.4 393.4C444.9 405.9 444.9 426.2 457.4 438.7C469.9 451.2 490.2 451.2 502.7 438.7L598.7 342.7C611.2 330.2 611.2 309.9 598.7 297.4L502.7 201.4C490.2 188.9 469.9 188.9 457.4 201.4zM182.7 201.3C170.2 188.8 149.9 188.8 137.4 201.3L41.4 297.3C28.9 309.8 28.9 330.1 41.4 342.6L137.4 438.6C149.9 451.1 170.2 451.1 182.7 438.6C195.2 426.1 195.2 405.8 182.7 393.3L109.3 320L182.6 246.6C195.1 234.1 195.1 213.8 182.6 201.3z" />
          </svg>
        </b-btn>
        <b-btn
          v-if="hasCommand('setHorizontalRule')"
          v-b-tooltip
          title="Horizontal Line"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().setHorizontalRule().run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="w-4 h-4"
            :class="{ 'opacity-40': !tiptap.isActive('horizontalRule') }"
          >
            <path d="M5 12h14" />
          </svg>
        </b-btn>
      </b-btn-group>
    </b-form-group>

    <b-form-group
      v-if="tiptap.isActive('image')"
      label="Image Alignment"
    >
      <b-btn-group>
        <b-btn
          v-if="hasCommand('setImageAlign')"
          v-b-tooltip
          title="Left"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().setImageAlign('left').run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': activeImageAlign !== 'left' }"
          >
            <path d="M384 128C384 145.7 369.7 160 352 160L128 160C110.3 160 96 145.7 96 128C96 110.3 110.3 96 128 96L352 96C369.7 96 384 110.3 384 128zM384 384C384 401.7 369.7 416 352 416L128 416C110.3 416 96 401.7 96 384C96 366.3 110.3 352 128 352L352 352C369.7 352 384 366.3 384 384zM96 256C96 238.3 110.3 224 128 224L512 224C529.7 224 544 238.3 544 256C544 273.7 529.7 288 512 288L128 288C110.3 288 96 273.7 96 256zM544 512C544 529.7 529.7 544 512 544L128 544C110.3 544 96 529.7 96 512C96 494.3 110.3 480 128 480L512 480C529.7 480 544 494.3 544 512z" />
          </svg>
        </b-btn>
        <b-btn
          v-if="hasCommand('setImageAlign')"
          v-b-tooltip
          title="Center"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().setImageAlign('center').run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': activeImageAlign !== 'center' }"
          >
            <path d="M448 128C448 110.3 433.7 96 416 96L224 96C206.3 96 192 110.3 192 128C192 145.7 206.3 160 224 160L416 160C433.7 160 448 145.7 448 128zM544 256C544 238.3 529.7 224 512 224L128 224C110.3 224 96 238.3 96 256C96 273.7 110.3 288 128 288L512 288C529.7 288 544 273.7 544 256zM96 512C96 529.7 110.3 544 128 544L512 544C529.7 544 544 529.7 544 512C544 494.3 529.7 480 512 480L128 480C110.3 480 96 494.3 96 512zM448 384C448 366.3 433.7 352 416 352L224 352C206.3 352 192 366.3 192 384C192 401.7 206.3 416 224 416L416 416C433.7 416 448 401.7 448 384z" />
          </svg>
        </b-btn>
        <b-btn
          v-if="hasCommand('setImageAlign')"
          v-b-tooltip
          title="Right"
          type="button"
          variant="white"
          class="h-[32px] w-[32px] p-0 hover:opacity-100"
          @click="tiptap.chain().focus().setImageAlign('right').run()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            class="w-4 h-4"
            :class="{ 'opacity-40': activeImageAlign !== 'right' }"
          >
            <path d="M544 128C544 145.7 529.7 160 512 160L288 160C270.3 160 256 145.7 256 128C256 110.3 270.3 96 288 96L512 96C529.7 96 544 110.3 544 128zM544 384C544 401.7 529.7 416 512 416L288 416C270.3 416 256 401.7 256 384C256 366.3 270.3 352 288 352L512 352C529.7 352 544 366.3 544 384zM96 256C96 238.3 110.3 224 128 224L512 224C529.7 224 544 238.3 544 256C544 273.7 529.7 288 512 288L128 288C110.3 288 96 273.7 96 256zM544 512C544 529.7 529.7 544 512 544L128 544C110.3 544 96 529.7 96 512C96 494.3 110.3 480 128 480L512 480C529.7 480 544 494.3 544 512z" />
          </svg>
        </b-btn>
      </b-btn-group>
    </b-form-group>

    <b-form-group
      v-if="hasCommand('insertTable') || isInTable"
      label="Table"
    >
      <div class="flex flex-col gap-2">
        <template v-if="isInTable">
          <b-btn
            v-b-tooltip
            title="Delete Table"
            variant="white"
            class="h-[32px] w-[32px] p-0 opacity-40 hover:opacity-100"
            type="button"
            :disabled="!canRunTableCmd('deleteTable')"
            @click="runTableCmd('deleteTable')"
          >
            <svg
              id="mdi-table-minus"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              class="w-4 h-4"
            >
              <path d="M15 19V17H23V19H15M4 3H18C19.11 3 20 3.9 20 5V12.08C18.45 11.82 16.92 12.18 15.68 13H12V17H13.08C12.97 17.68 12.97 18.35 13.08 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4Z" />
            </svg>
          </b-btn>

          <b-btn-group>
            <b-btn
              v-b-tooltip
              title="Prepend Row"
              variant="white"
              class="h-[32px] w-[32px] p-0 opacity-40 hover:opacity-100"
              type="button"
              :disabled="!canRunTableCmd('addRowBefore')"
              @click="runTableCmd('addRowBefore')"
            >
              <svg
                id="mdi-table-row-plus-before"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="w-4 h-4"
              >
                <path d="M22,14A2,2 0 0,0 20,12H4A2,2 0 0,0 2,14V21H4V19H8V21H10V19H14V21H16V19H20V21H22V14M4,14H8V17H4V14M10,14H14V17H10V14M20,14V17H16V14H20M11,10H13V7H16V5H13V2H11V5H8V7H11V10Z" />
              </svg>
            </b-btn>
            <b-btn
              v-b-tooltip
              title="Append Row"
              variant="white"
              class="h-[32px] w-[32px] p-0 opacity-40 hover:opacity-100"
              type="button"
              :disabled="!canRunTableCmd('addRowAfter')"
              @click="runTableCmd('addRowAfter')"
            >
              <svg
                id="mdi-table-row-plus-after"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="w-4 h-4"
              >
                <path d="M22,10A2,2 0 0,1 20,12H4A2,2 0 0,1 2,10V3H4V5H8V3H10V5H14V3H16V5H20V3H22V10M4,10H8V7H4V10M10,10H14V7H10V10M20,10V7H16V10H20M11,14H13V17H16V19H13V22H11V19H8V17H11V14Z" />
              </svg>
            </b-btn>
            <b-btn
              v-b-tooltip
              title="Delete Row"
              variant="white"
              class="h-[32px] w-[32px] p-0 opacity-40 hover:opacity-100"
              type="button"
              :disabled="!canRunTableCmd('deleteRow')"
              @click="runTableCmd('deleteRow')"
            >
              <svg
                id="mdi-table-row-remove"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="w-4 h-4"
              >
                <path d="M9.41,13L12,15.59L14.59,13L16,14.41L13.41,17L16,19.59L14.59,21L12,18.41L9.41,21L8,19.59L10.59,17L8,14.41L9.41,13M22,9A2,2 0 0,1 20,11H4A2,2 0 0,1 2,9V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V9M4,9H8V6H4V9M10,9H14V6H10V9M16,9H20V6H16V9Z" />
              </svg>
            </b-btn>
          </b-btn-group>

          <b-btn-group>
            <b-btn
              v-b-tooltip
              title="Prepend Column"
              variant="white"
              class="h-[32px] w-[32px] p-0 opacity-40 hover:opacity-100"
              type="button"
              :disabled="!canRunTableCmd('addColumnBefore')"
              @click="runTableCmd('addColumnBefore')"
            >
              <svg
                id="mdi-table-column-plus-before"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="w-4 h-4"
              >
                <path d="M13,2A2,2 0 0,0 11,4V20A2,2 0 0,0 13,22H22V2H13M20,10V14H13V10H20M20,16V20H13V16H20M20,4V8H13V4H20M9,11H6V8H4V11H1V13H4V16H6V13H9V11Z" />
              </svg>
            </b-btn>
            <b-btn
              v-b-tooltip
              title="Append Column"
              variant="white"
              class="h-[32px] w-[32px] p-0 opacity-40 hover:opacity-100"
              type="button"
              :disabled="!canRunTableCmd('addColumnAfter')"
              @click="runTableCmd('addColumnAfter')"
            >
              <svg
                id="mdi-table-column-plus-after"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="w-4 h-4"
              >
                <path d="M11,2A2,2 0 0,1 13,4V20A2,2 0 0,1 11,22H2V2H11M4,10V14H11V10H4M4,16V20H11V16H4M4,4V8H11V4H4M15,11H18V8H20V11H23V13H20V16H18V13H15V11Z" />
              </svg>
            </b-btn>
            <b-btn
              v-b-tooltip
              title="Delete Column"
              variant="white"
              class="h-[32px] w-[32px] p-0 opacity-40 hover:opacity-100"
              type="button"
              :disabled="!canRunTableCmd('deleteColumn')"
              @click="runTableCmd('deleteColumn')"
            >
              <svg
                id="mdi-table-column-remove"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="w-4 h-4"
              >
                <path d="M4,2H11A2,2 0 0,1 13,4V20A2,2 0 0,1 11,22H4A2,2 0 0,1 2,20V4A2,2 0 0,1 4,2M4,10V14H11V10H4M4,16V20H11V16H4M4,4V8H11V4H4M17.59,12L15,9.41L16.41,8L19,10.59L21.59,8L23,9.41L20.41,12L23,14.59L21.59,16L19,13.41L16.41,16L15,14.59L17.59,12Z" />
              </svg>
            </b-btn>
          </b-btn-group>

          <b-btn-group>
            <b-btn
              v-b-tooltip
              title="Merge Cells"
              variant="white"
              class="h-[32px] w-[32px] p-0 opacity-40 hover:opacity-100"
              type="button"
              @click="runTableCmd('mergeCells')"
            >
              <svg
                id="mdi-table-merge-cells"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="w-4 h-4"
              >
                <path d="M5,10H3V4H11V6H5V10M19,18H13V20H21V14H19V18M5,18V14H3V20H11V18H5M21,4H13V6H19V10H21V4M8,13V15L11,12L8,9V11H3V13H8M16,11V9L13,12L16,15V13H21V11H16Z" />
              </svg>
            </b-btn>
            <b-btn
              v-b-tooltip
              title="Split Cell"
              variant="white"
              class="h-[32px] w-[32px] p-0 opacity-40 hover:opacity-100"
              type="button"
              @click="runTableCmd('splitCell')"
            >
              <svg
                id="mdi-table-split-cell"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="w-4 h-4"
              >
                <path d="M19 14H21V20H3V14H5V18H19V14M3 4V10H5V6H19V10H21V4H3M11 11V13H8V15L5 12L8 9V11H11M16 11V9L19 12L16 15V13H13V11H16Z" />
              </svg>
            </b-btn>
          </b-btn-group>

          <b-btn-group>
            <b-btn
              v-b-tooltip
              title="Header Row"
              variant="white"
              :class="`h-[32px] w-[32px] p-0 hover:opacity-100 ${isHeaderRowActive ? 'opacity-100' : 'opacity-40'}`"
              type="button"
              :disabled="!canRunTableCmd('toggleHeaderRow')"
              @click="runTableCmd('toggleHeaderRow')"
            >
              <svg
                id="mdi-table-row"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="w-4 h-4"
              >
                <path
                  d="M22,14A2,2 0 0,1 20,16H4A2,2 0 0,1 2,14V10A2,2 0 0,1 4,8H20A2,2 0 0,1 22,10V14M4,14H8V10H4V14M10,14H14V10H10V14M16,14H20V10H16V14Z"
                />
              </svg>
            </b-btn>
            <b-btn
              v-b-tooltip
              title="Header Column"
              variant="white"
              class="h-[32px] w-[32px] p-0 opacity-40 hover:opacity-100"
              type="button"
              @click="runTableCmd('toggleHeaderColumn')"
            >
              <svg
                id="mdi-table-column"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="w-4 h-4"
              >
                <path
                  d="M8,2H16A2,2 0 0,1 18,4V20A2,2 0 0,1 16,22H8A2,2 0 0,1 6,20V4A2,2 0 0,1 8,2M8,10V14H16V10H8M8,16V20H16V16H8M8,4V8H16V4H8Z"
                />
              </svg>
            </b-btn>
          </b-btn-group>
        </template>

        <b-btn
          v-else
          v-b-tooltip
          title="Insert Table"
          variant="white"
          class="h-[32px] w-[32px] p-0 opacity-40 hover:opacity-100"
          type="button"
          :disabled="!canRunTableCmd('insertTable', { rows: 3, cols: 3, withHeaderRow: true })"
          @click="insertDefaultTable"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            class="w-4 h-4"
          >
            <path d="M5,4H19A2,2 0 0,1 21,6V18A2,2 0 0,1 19,20H5A2,2 0 0,1 3,18V6A2,2 0 0,1 5,4M5,8V12H11V8H5M13,8V12H19V8H13M5,14V18H11V14H5M13,14V18H19V14H13Z" />
          </svg>
        </b-btn>
      </div>
    </b-form-group>

    <template v-if="isInTable">
      <b-form-group>
        <div class="flex items-center justify-between">
          <label class="mb-0 pb-0">
            Header Color
          </label>

          <sid-color
            :sid="`${sid} .tiptap.ProseMirror th`"
            rule-name="background-color"
          />
        </div>
      </b-form-group>

      <b-form-group>
        <div class="flex items-center justify-between">
          <label class="mb-0 pb-0">
            Cell Color
          </label>

          <sid-color
            :sid="`${sid} .tiptap.ProseMirror td`"
            rule-name="background-color"
          />
        </div>
      </b-form-group>

      <b-form-group>
        <div class="flex items-center justify-between">
          <label class="pb-0">Cell Border Type</label>

          <sid-select
            :sid="`${sid} .tiptap.ProseMirror th, ${sid} .tiptap.ProseMirror td`"
            rule-name="border-style"
            :searchable="false"
            class="w-[118px]"
            :options="[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]"
          />
        </div>
      </b-form-group>

      <b-form-group>
        <sid-linked-group
          :sid="`${sid} .tiptap.ProseMirror th, ${sid} .tiptap.ProseMirror td`"
          label="Cell Border Width"
          rule-name="border"
          class="!mb-[7px]"
          :angles="[
            {
              text: '',
              value: 'top-width'
            },
            {
              text: '',
              value: 'right-width'
            },
            {
              text: '',
              value: 'bottom-width'
            },
            {
              text: '',
              value: 'left-width'
            }
          ]"
        />

        <div class="flex w-full justify-end">
          <sid-color
            :sid="`${sid} .tiptap.ProseMirror th, ${sid} .tiptap.ProseMirror td`"
            rule-name="border-color"
          />
        </div>
      </b-form-group>

      <sid-linked-group
        label="Cell Padding"
        :sid="`${sid} .tiptap.ProseMirror th, ${sid} .tiptap.ProseMirror td`"
        rule-name="padding"
        :min="0"
        :angles="[
          {
            text: '',
            value: 'top'
          },
          {
            text: '',
            value: 'right'
          },
          {
            text: '',
            value: 'bottom'
          },
          {
            text: '',
            value: 'left'
          }
        ]"
      />
    </template>

    <b-form-group>
      <div class="d-flex align-items-center justify-between sid-select">
        <label class="mb-0 mt-2">Text Link</label>

        <div>
          <b-btn
            :class="{ 'is-active': linkMenuIsActive }"
            class="h-[29px] w-[29px] flex items-center justify-center p-0"
            variant="white"
            @click="linkMenuIsActive = !linkMenuIsActive"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="w-4 h-4"
            >
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
            </svg>
          </b-btn>
        </div>
      </div>

      <template v-if="linkMenuIsActive">
        <tiptap-link
          :value="linkMutation"
          class="mt-2"
          :sid="sid"
          hide-styles
          @change="onLinkChange"
        >
          <b-btn
            block
            variant="primary"
            @click="applyLinkFromPanel"
          >
            {{ linkSaveText }}
          </b-btn>
          <b-btn
            v-if="tiptap.isActive('link')"
            block
            variant="danger"
            @click="unsetLink"
          >
            Remove Link
          </b-btn>
        </tiptap-link>
      </template>
    </b-form-group>

    <b-form-group>
      <div class="d-flex items-center justify-between sid-select">
        <label class="mb-0 mt-2">Global Variable</label>

        <div>
          <template v-if="globalVariableActive">
            <b-btn
              class="text-danger"
              variant="link"
              @click="() => {
                tiptap.commands.globalVariable({ remove: true })
                globalVariableActive = false
              }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="w-4 h-4"
              >
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
                <path d="M3 6h18" />
                <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
              </svg>
            </b-btn>
          </template>

          <b-btn
            :class="{ 'is-active': globalVariableActive }"
            class="h-[29px] w-[29px] flex items-center justify-center p-0"
            variant="white"
            @click="globalVariableActive = !globalVariableActive"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="w-4 h-4"
            >
              <path d="M8 21s-4-3-4-9 4-9 4-9" />
              <path d="M16 3s4 3 4 9-4 9-4 9" />
              <line
                x1="15"
                x2="9"
                y1="9"
                y2="15"
              />
              <line
                x1="9"
                x2="15"
                y1="9"
                y2="15"
              />
            </svg>
          </b-btn>
        </div>
      </div>

      <template v-if="globalVariableActive">
        <global-variable-content
          class="mt-3"
          :selected="getMarkAttrs('globalVariable')"
          @change="applyGlobalVariable"
        />

        <global-variable-link
          class="mt-3"
          :selected="getMarkAttrs('globalVariableLink')"
          @change="applyGlobalVariableLink"
        />
      </template>
    </b-form-group>
  </div>
</template>

<script>
import _ from 'lodash'
import {mapState} from 'vuex'
import {
  addSidRules as applySidRules,
  getSidStyle as readSidStyle,
  getStylesheetEl,
  parseCssLength
} from '@/utils/useStylesheet'
import RangeSlider from '@/components/editor/components/sid-controls/RangeSlider.vue'
import ColorPickerPlaceholder from '@/components/editor/utils/ColorPickerPlaceholder.vue'
import ColorPickerFlat from '@/components/editor/utils/ColorPickerFlat.vue'
import TiptapLink from '@/components/editor/controls/TiptapLink.vue'
import GlobalVariableContent from '@/components/editor/components/GlobalVariableContent.vue'
import GlobalVariableLink from '@/components/editor/components/GlobalVariableLink.vue'
import BackgroundType from '@/components/editor/controls/BackgroundType.vue'
import GradientBackground from '@/components/editor/controls/GradientBackground.vue'
import SidSelect from '@/components/editor/components/sid-controls/SidSelect.vue'
import SidColor from '@/components/editor/components/sid-controls/SidColor.vue'
import SidLinkedGroup from '@/components/editor/components/sid-controls/SidLinkedGroup.vue'
import UploadAsset
  from '@/components/editor/components/sid-controls/sid-control-pressets/background-image/UploadAsset.vue'

export default {
  name: 'TiptapSettings',
  directives: {
    clickOutside: {
      bind (el, binding, vnode) {
        el.__vueClickOutside__ = function (event) {
          // If click was inside the bound element, ignore.
          if (el.contains(event.target)) return

          // Call provided handler.
          if (typeof binding.value === 'function') {
            binding.value.call(vnode.context, event)
          }
        }
        document.addEventListener('click', el.__vueClickOutside__, true)
        document.addEventListener('touchstart', el.__vueClickOutside__, true)
      },
      unbind (el) {
        document.removeEventListener('click', el.__vueClickOutside__, true)
        document.removeEventListener('touchstart', el.__vueClickOutside__, true)
        delete el.__vueClickOutside__
      }
    }
  },
  components: {
    UploadAsset,
    SidLinkedGroup, SidColor, SidSelect,
    BackgroundType,
    GradientBackground,
    GlobalVariableLink,
    GlobalVariableContent,
    TiptapLink,
    ColorPickerFlat,
    ColorPickerPlaceholder,
    RangeSlider
  },
  props: {
    sid: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      initEditor: true,
      globalVariableActive: false,
      typeColor: false,
      typeBGColor: false,
      linkMenuIsActive: false,
      linkAttrs: {
        href: '',
        target: '_blank',
        rel: 'noopener noreferrer nofollow'
      },
      tagOptions: [
        {
          label: 'Heading 1',
          value: 'h1'
        },
        {
          label: 'Heading 2',
          value: 'h2'
        },
        {
          label: 'Heading 3',
          value: 'h3'
        },
        {
          label: 'Heading 4',
          value: 'h4'
        },
        {
          label: 'Heading 5',
          value: 'h5'
        },
        {
          label: 'Heading 6',
          value: 'h6'
        },
        {
          label: 'Paragraph',
          value: 'p'
        }
      ],
      fontFamily: '',
      fontWeight: '',
      fontSize: '',
      fontSizeUnit: 'px',
      fontSizeDefaultUnit: 'px',
      fontSizeUnits: ['px', 'rem'],
      letterSpacing: '',
      letterSpacingUnit: 'em',
      letterSpacingDefaultUnit: 'em',
      letterSpacingUnits: ['px', 'em'],
      lineHeight: '',
      lineHeightUnit: 'em',
      lineHeightDefaultUnit: 'em',
      lineHeightUnits: ['px', 'em', '%'],
      textColor: '#44474A',
      bgColor: '#ffffff',
      editorStateTick: 0,
      boundEditor: null,
      colorUnit: null,
      colorType: {
        backgroundType: null
      },
      backgroundGradient: {
        backgroundGradient: [
          {
            'color': 'rgb(119,171,255)',
            'position': 0
          },
          {
            'color': 'rgb(0,60,152)',
            'position': 100
          }
        ]
      },
      lastGradientCss: '',
      bgColorType: {
        backgroundType: null
      },
      bgBackgroundGradient: {
        backgroundGradient: [
          {
            'color': 'rgb(119,171,255)',
            'position': 0
          },
          {
            'color': 'rgb(0,60,152)',
            'position': 100
          }
        ]
      },
      lastBgGradientCss: ''
    }
  },
  computed: {
    ...mapState('editor', {
      globalStyles: state => state.globalStyles,
      tiptap: state => state.tiptap,
      resolution: state => state.resolution,
      tablet: state => state.tablet
    }),
    resolutioner () {
      return this.tablet ? 'md' : this.resolution
    },
    ...mapState('font', {
      allCustomFonts: state => state.allCustomFonts,
      allCustomFontsFromCSS: state => state.allCustomFontsFromCSS
    }),
    addedGoogleFonts () {
      return this.globalStyles.font.addedGoogleFonts
    },
    selectedMark () {
      // Keep this computed reactive to editor selection changes.
      void this.editorStateTick
      const { empty, from, to } = this.tiptap.state.selection
      return !empty && from !== to
    },
    commands () {
      return this.tiptap?.commands || {}
    },
    indentLevel () {
      void this.editorStateTick
      if (!this.tiptap) return 0
      try {
        const { $from } = this.tiptap.state.selection
        const level = $from?.parent?.attrs?.indent
        return typeof level === 'number' ? level : 0
      } catch (e) {
        return 0
      }
    },
    isInTable () {
      void this.editorStateTick
      if (!this.tiptap) return false
      // Different table extensions report different active nodes.
      return (
        this.tiptap.isActive('table') ||
        this.tiptap.isActive('tableCell') ||
        this.tiptap.isActive('tableHeader') ||
        this.tiptap.isActive('tableRow')
      )
    },
    isHeaderRowActive () {
      void this.editorStateTick
      if (!this.tiptap) return false
      return this.tiptap.isActive('tableHeader')
    },
    isActive () {
      return {
        link: () => (this.tiptap ? this.tiptap.isActive('link') : false)
      }
    },
    linkSaveText () {
      void this.editorStateTick
      return (this.tiptap && this.tiptap.isActive('link')) ? 'Update link' : 'Add link'
    },
    tagMutation: {
      get () {
        void this.editorStateTick
        if (!this.tiptap) return 'p'

        for (let level = 1; level <= 6; level++) {
          if (this.tiptap.isActive('heading', { level })) {
            return `h${level}`
          }
        }

        if (this.tiptap.isActive('paragraph')) {
          return 'p'
        }

        return 'p'
      },
      set (val) {
        this.applyTag(val)
      }
    },
    fontFamilyMutation: {
      get () {
        void this.editorStateTick
        return this.tiptap.getAttributes('textStyle').fontFamily || this.getSidStyle(this.sid, 'font-family')
      },
      set (val) {
        this.applyFontFamily(val)
      }
    },
    fontsFamilyOptions () {
      const fonts = []

      fonts.push('')
      fonts.push(...this.allCustomFonts.map(font => font.font_name))
      fonts.push(...this.addedGoogleFonts.map(font => font.family))
      fonts.push(...this.allCustomFontsFromCSS.map(font => font.family))

      return _.uniq(fonts).sort()
    },
    fontWeightMutation: {
      get () {
        void this.editorStateTick
        const attrs = this.tiptap?.getAttributes('textStyle') || {}
        return this.getResponsiveMarkStyleFromStyle(attrs.style, 'font-weight') || attrs.fontWeight || this.getSidStyle(this.sid, 'font-weight')
      },
      set (val) {
        this.applyFontWeight(val)
      }
    },
    fontWeightOptions () {
      let options = []
      const family = this.fontFamilyMutation

      let font = this.allCustomFonts.find(group => group.font_name.toLowerCase() === family.toLowerCase())

      if (!font) {
        font = this.addedGoogleFonts.find(font => font.family.toLowerCase() === family.toLowerCase())
      }

      if (!font) {
        font = this.allCustomFontsFromCSS.find(font => font.family.toLowerCase() === family.toLowerCase())
      }

      if (!font) return options

      options.push(..._.sortBy((font.fonts || font.variants)
        .map(variant => {
          return {
            label: variant.font_weight || variant,
            value: variant.font_weight || variant
          }
        }), (e) => parseInt(e.value)))

      return options
    },
    fontSizeMutation: {
      get () {
        void this.editorStateTick
        const attrs = this.tiptap?.getAttributes('textStyle') || {}
        const nodeFontSize = this.getSelectionNodeFontSize()
        const tagOrClassFontSize = this.getTagOrClassFontSize()
        const sidFontSize = this.getSidStyle(this.sid, 'font-size') || ''

        const markFontSize = this.getResponsiveMarkStyleFromStyle(attrs.style, 'font-size') ||
          attrs.fontSize ||
          nodeFontSize ||
          ''
        const source = this.selectedMark
          ? (markFontSize || tagOrClassFontSize || sidFontSize || '')
          : (sidFontSize || markFontSize || tagOrClassFontSize || '')
        const { value, unit } = parseCssLength(source)

        if (unit && this.fontSizeUnits.includes(unit)) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.fontSizeUnit = unit
        }

        return value ?? ''
      },
      set (val) {
        this.applyFontSize(val)
      }
    },
    letterSpacingMutation: {
      get () {
        void this.editorStateTick
        const attrs = this.tiptap?.getAttributes('textStyle') || {}

        const source = this.getResponsiveMarkStyleFromStyle(attrs.style, 'letter-spacing') || attrs.letterSpacing || this.getSidStyle(this.sid, 'letter-spacing') || ''
        const { value, unit } = parseCssLength(source)

        if (unit && this.letterSpacingUnits.includes(unit)) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.letterSpacingUnit = unit
        }

        return value ?? ''
      },
      set (val) {
        this.applyLetterSpacing(val)
      }
    },
    lineHeightMutation: {
      get () {
        void this.editorStateTick
        const attrs = this.tiptap?.getAttributes('textStyle') || {}
        const source = this.getResponsiveMarkStyleFromStyle(attrs.style, 'line-height') || attrs.lineHeight || this.getSidStyle(this.sid, 'line-height') || ''
        const { value, unit } = parseCssLength(source)

        if (unit && this.lineHeightUnits.includes(unit)) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.lineHeightUnit = unit
        }

        return value ?? ''
      },
      set (val) {
        this.applyLineHeight(val)
      }
    },
    textColorTypeMutation () {
      void this.editorStateTick
      const attrs = this.tiptap?.getAttributes('textStyle') || {}

      const gradientValue = (this.selectedMark && attrs.gradientColor) || this.getSidStyle(this.sid, 'background-image') || ''

      if (gradientValue && gradientValue.includes('linear-gradient')) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.colorType.backgroundType = 'gradient'
        this.syncBackgroundGradientFromCss(gradientValue)
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.colorType.backgroundType = null
      }

      return this.colorType.backgroundType
    },
    textColorMutation: {
      get () {
        void this.editorStateTick
        const attrs = this.tiptap?.getAttributes('textStyle') || {}

        const value = attrs.color || this.getSidStyle(this.sid, 'color') || ''

        return value ?? ''
      },
      set (val) {
        this.applyTextColor(val)
      }
    },
    bgColorTypeMutation () {
      void this.editorStateTick
      const attrs = this.tiptap?.getAttributes('textStyle') || {}

      const gradientValue = (this.selectedMark && attrs.bgGradientColor) || this.getSidStyle(this.sid, 'background-image') || ''

      if (gradientValue && gradientValue.includes('linear-gradient')) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.bgColorType.backgroundType = 'gradient'
        this.syncBgGradientFromCss(gradientValue)
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.bgColorType.backgroundType = null
      }

      return this.bgColorType.backgroundType
    },
    backgroundColorMutation: {
      get () {
        void this.editorStateTick
        const attrs = this.tiptap?.getAttributes('textStyle') || {}

        const value = attrs.backgroundColor || attrs.bgColor || this.getSidStyle(this.sid, 'background-color') || ''

        return value ?? ''
      },
      set (val) {
        this.applyBgColor(val)
      }
    },
    linkMutation () {
      void this.editorStateTick
      const attrs = this.getLinkAttributes(this.getMarkAttrs('link'))
      const hrefStr = (attrs && typeof attrs.href === 'string') ? attrs.href : ''

      // TiptapLink expects `value.href` to be an object (and later writes `value.href.href = ...`).
      return {
        id: null,
        href: {
          id: 'custom-link',
          title: 'Custom Link',
          href: hrefStr,
          slug: hrefStr || null
        },
        target: attrs.target || '_blank',
        rel: attrs.rel || 'noopener noreferrer nofollow',
        fromGlobalStyle: false,
        styleeffect: null,
        file: null
      }
    },
    activeTextAlign () {
      void this.editorStateTick
      if (!this.tiptap) return null

      const sel = this.tiptap.state?.selection
      const parent = sel?.$from?.parent
      const parentTypeName = parent?.type?.name
      if (!parent || !['paragraph', 'heading'].includes(parentTypeName)) return null

      const attrs = parent.attrs || {}
      return this.getResponsiveMarkStyleFromStyle(attrs.style, 'text-align') || attrs.textAlign || null
    },
    activeImageAlign () {
      void this.editorStateTick
      if (!this.tiptap) return null

      // Only relevant when an image is selected or the cursor is next to an image
      const sel = this.tiptap.state?.selection
      if (!sel) return null

      const imageTypeName = 'image'

      // Helper: find image position (node selection or adjacent to cursor)
      const findImagePos = () => {
        if (sel.node && sel.node.type?.name === imageTypeName) {
          return typeof sel.from === 'number' ? sel.from : null
        }

        const $from = sel.$from
        if (!$from) return null

        const before = $from.nodeBefore
        if (before && before.type?.name === imageTypeName) {
          return $from.pos - before.nodeSize
        }

        const after = $from.nodeAfter
        if (after && after.type?.name === imageTypeName) {
          return $from.pos
        }

        return null
      }

      const pos = findImagePos()
      if (pos == null) return null

      const nodeAtPos = this.tiptap.state.doc.nodeAt(pos)
      if (!nodeAtPos || nodeAtPos.type?.name !== imageTypeName) return null

      const style = (nodeAtPos.attrs && nodeAtPos.attrs.style) ? String(nodeAtPos.attrs.style) : ''
      const styleObj = this.parseInlineStyle(style)
      const bp = this.getResponsiveBreakpoint()
      const prefix = this.getResponsivePrefix()

      const mlVar = `--${prefix}-img-ml-${bp}`
      const mrVar = `--${prefix}-img-mr-${bp}`

      const ml = styleObj[mlVar] || null
      const mr = styleObj[mrVar] || null

      if (ml === '0' && mr === 'auto') return 'left'
      if (ml === 'auto' && mr === 'auto') return 'center'
      if (ml === 'auto' && mr === '0') return 'right'

      return null
    }
  },
  methods: {
    getStyleSheetByResolution () {
      const styleEl = getStylesheetEl()
      const keys = {
        lg: 0,
        md: 1,
        sm: 2
      }

      return styleEl?.sheet?.cssRules?.[keys[this.resolutioner]] || null
    },
    getSidStyles (sid = this.sid, styleSheet = this.getStyleSheetByResolution()) {
      if (!styleSheet || !styleSheet.cssRules) return []
      return [...styleSheet.cssRules].filter(_s => _s.selectorText === sid)
    },
    getSidStyle (sid = this.sid, rule) {
      if (!rule) return ''

      const styleSheet = this.getStyleSheetByResolution()
      if (!styleSheet || !styleSheet.cssRules) {
        return readSidStyle(sid, rule)
      }

      const rules = this.getSidStyles(sid, styleSheet)
      for (let i = 0; i < rules.length; i++) {
        if (rules[i].selectorText === sid && rules[i].style[rule]) {
          return rules[i].style[rule]
        }
      }

      if (rule === 'position') return 'static'

      const $el = document.querySelector(sid)
      if (!$el) return ''

      return window.getComputedStyle($el).getPropertyValue(rule)
    },
    addSidRules (rules, options = {}) {
      const styleSheet = this.getStyleSheetByResolution()
      const varName = typeof options === 'string' ? options : (options && options.varName ? options.varName : null)
      const variable = options && typeof options === 'object' ? options.variable : null

      if (!styleSheet || !styleSheet.cssRules) {
        return applySidRules(rules, options)
      }

      rules.forEach((rule) => {
        let j = 1
        const selector = rule[0]
        const cleanSelector = selector.replace(/::after|::before|:hover/, '')
        let propStr = ''

        if (Array.isArray(rule[1][0])) {
          rule = rule[1]
          j = 0
        }

        const pl = rule.length

        while (j < pl) {
          const prop = rule[j]
          const sidRules = this.getSidStyles(cleanSelector, styleSheet)

          if (sidRules.length) {
            const styleObject = sidRules[0].style

            if (prop[1] !== '') {
              styleObject.setProperty(prop[0], prop[1])

              if (varName) {
                styleObject.setProperty(varName, variable || prop[1])
              }
            } else {
              styleObject.removeProperty(prop[0])

              if (varName) {
                styleObject.removeProperty(varName)
              }
            }
            return
          }

          sidRules.forEach(_s => {
            propStr += _s.style.cssText
          })

          propStr += `${prop[0]}: ${prop[1]}${prop[2] ? ' !important' : ''};\n`
          j++
        }

        styleSheet.insertRule(`${selector}{${propStr}}`, styleSheet.cssRules.length)
      })
    },
    parseInlineStyle (style) {
      const styleObj = {}

      String(style || '').split(';').forEach(part => {
        const p = part.trim()
        if (!p) return

        const idx = p.indexOf(':')
        if (idx === -1) return

        const key = p.slice(0, idx).trim()
        const value = p.slice(idx + 1).trim()

        if (key) styleObj[key] = value
      })

      return styleObj
    },
    getResponsiveBreakpoint () {
      const breakpoints = this.getResponsiveBreakpoints()
      const fromViewport = this.resolutioner

      if (breakpoints.includes(fromViewport)) {
        return fromViewport
      }

      return this.tiptap?.storage?.responsiveEngine?.breakpoint || breakpoints[0] || 'lg'
    },
    getResponsivePrefix () {
      const responsiveEngine = this.tiptap?.extensionManager?.extensions?.find(ext => ext.name === 'responsiveEngine')
      return responsiveEngine?.options?.prefix || 'vp'
    },
    getResponsiveBreakpoints () {
      const responsiveEngine = this.tiptap?.extensionManager?.extensions?.find(ext => ext.name === 'responsiveEngine')
      const breakpoints = responsiveEngine?.options?.breakpoints
      if (Array.isArray(breakpoints) && breakpoints.length) {
        return breakpoints
      }
      return ['lg', 'md', 'sm']
    },
    syncResponsiveBreakpoint (breakpoint = this.getResponsiveBreakpoint()) {
      if (!this.tiptap) return
      if (!this.hasCommand('setResponsiveBreakpoint')) return
      if (!breakpoint) return

      this.tiptap.commands.setResponsiveBreakpoint(breakpoint)
    },
    getResponsiveMarkStyleFromStyle (style, cssProp) {
      if (!style) return ''

      const styleObj = this.parseInlineStyle(style)
      const prefix = this.getResponsivePrefix()
      const bp = this.getResponsiveBreakpoint()
      const breakpoints = this.getResponsiveBreakpoints()
      const bpIndex = breakpoints.indexOf(bp)

      if (bpIndex === -1) return ''

      for (let i = bpIndex; i >= 0; i--) {
        const varName = `--${prefix}-${cssProp}-${breakpoints[i]}`
        const value = styleObj[varName]
        if (typeof value === 'string' && value.trim()) {
          return value.trim()
        }
      }

      // Legacy fallback for non-responsive inline styles.
      const direct = styleObj[cssProp]
      if (typeof direct === 'string' && direct.trim()) {
        return direct.trim()
      }

      return ''
    },
    getSelectionNodeFontSize () {
      if (!this.tiptap) return ''

      const parent = this.tiptap.state?.selection?.$from?.parent
      const attrs = parent?.attrs || {}

      return this.getResponsiveMarkStyleFromStyle(attrs.style, 'font-size') || attrs.fontSize || ''
    },
    getActiveTextStyleType () {
      if (!this.tiptap) return 'paragraph'

      for (let level = 1; level <= 6; level++) {
        if (this.tiptap.isActive('heading', { level })) {
          return `h${level}`
        }
      }

      const parent = this.tiptap.state?.selection?.$from?.parent
      const className = String(parent?.attrs?.class || '').toLowerCase()

      const classMatch = /(?:^|\s)\.?h([1-6])(?:\s|$)/.exec(className)
      if (classMatch) return `h${classMatch[1]}`

      if (/\bparagraph\b/.test(className)) return 'paragraph'
      if (this.tiptap.isActive('paragraph')) return 'paragraph'

      return 'paragraph'
    },
    getTagOrClassFontSize () {
      const type = this.getActiveTextStyleType()
      const bp = this.getResponsiveBreakpoint()

      const textStyles = this.globalStyles?.textStyles || {}
      const style = textStyles[type]
      if (!style || !style.fontSize) return ''

      return style.fontSize[bp] || style.fontSize.lg || ''
    },
    onEditorStateChange () {
      this.editorStateTick += 1
    },
    bindEditorEvents (editor = this.tiptap) {
      if (!editor || typeof editor.on !== 'function') return
      this.unbindEditorEvents()

      this.boundEditor = editor
      editor.on('selectionUpdate', this.onEditorStateChange)
      editor.on('transaction', this.onEditorStateChange)
      editor.on('update', this.onEditorStateChange)
      editor.on('focus', this.onEditorStateChange)
      editor.on('blur', this.onEditorStateChange)
    },
    unbindEditorEvents (editor = this.boundEditor) {
      if (!editor || typeof editor.off !== 'function') return
      editor.off('selectionUpdate', this.onEditorStateChange)
      editor.off('transaction', this.onEditorStateChange)
      editor.off('update', this.onEditorStateChange)
      editor.off('focus', this.onEditorStateChange)
      editor.off('blur', this.onEditorStateChange)

      if (editor === this.boundEditor) {
        this.boundEditor = null
      }
    },
    onClickOutsideTextColorPicker (event) {
      // Only act when the picker is open
      if (!this.typeColor) return

      // Ignore clicks on the invoker button/placeholder (so it can toggle normally)
      const invokerRef = this.$refs.colorPickerInvoker
      const invokerEl = invokerRef && (invokerRef.$el || invokerRef)
      if (invokerEl && typeof invokerEl.contains === 'function' && invokerEl.contains(event.target)) {
        return
      }

      this.typeColor = false
    },
    onClickOutsideBgColorPicker (event) {
      if (!this.typeBGColor) return

      const invokerRef = this.$refs.bgColorPickerInvoker
      const invokerEl = invokerRef && (invokerRef.$el || invokerRef)
      if (invokerEl && typeof invokerEl.contains === 'function' && invokerEl.contains(event.target)) {
        return
      }

      this.typeBGColor = false
    },
    hasCommand (name) {
      return !!(this.tiptap && this.tiptap.commands && typeof this.tiptap.commands[name] === 'function')
    },
    indentText () {
      if (!this.tiptap || this.isInTable) return

      if (this.hasCommand('indent')) {
        this.tiptap.chain().focus().indent().run()
        return
      }

      if (this.hasCommand('setIndent')) {
        const next = Math.min(8, this.indentLevel + 1)
        this.tiptap.chain().focus().setIndent(next).run()
      }
    },
    outdentText () {
      if (!this.tiptap || this.isInTable) return

      if (this.hasCommand('outdent')) {
        this.tiptap.chain().focus().outdent().run()
        return
      }

      if (this.hasCommand('setIndent')) {
        const next = Math.max(0, this.indentLevel - 1)
        this.tiptap.chain().focus().setIndent(next).run()
      }
    },
    canRunTableCmd (name, ...args) {
      if (!this.tiptap) return false
      if (!this.hasCommand(name)) return false
      if (!this.tiptap.can || typeof this.tiptap.can !== 'function') return true

      const canChain = this.tiptap.can().chain().focus()
      if (!canChain || typeof canChain[name] !== 'function') return false
      return canChain[name](...args).run()
    },
    runTableCmd (name, ...args) {
      if (!this.tiptap) return
      if (!this.hasCommand(name)) return
      // Most table commands live on the editor chain
      const chain = this.tiptap.chain().focus()
      const fn = chain[name]
      if (typeof fn !== 'function') return
      fn.apply(chain, args)
      const ok = chain.run()

      if (ok) return

      // When the last row/column is removed, some table impls return false.
      // Fallback to deleting the table to avoid "dead" controls.
      if ((name === 'deleteRow' || name === 'deleteColumn') && this.hasCommand('deleteTable')) {
        this.tiptap.chain().focus().deleteTable().run()
      }
    },
    insertDefaultTable () {
      if (!this.tiptap) return
      if (!this.hasCommand('insertTable')) return
      // Common defaults; table extension usually accepts this signature
      this.runTableCmd('insertTable', { rows: 3, cols: 3, withHeaderRow: true })
    },

    openImagePicker () {
      const input = this.$refs.imageInput
      if (input && typeof input.click === 'function') {
        input.click()
      }
    },

    async onImagePicked (event) {
      if (!this.tiptap) return
      if (!this.hasCommand('setImage')) return

      const input = event && event.target
      const files = input && input.files ? Array.from(input.files) : []
      if (!files.length) return

      try {
        for (const file of files) {
          if (!file || !file.type || !file.type.startsWith('image/')) continue

          // Replace this with your real server upload that returns a public URL.
          // For now, we fall back to base64 so the feature works immediately.
          const src = await this.readFileAsDataURL(file)
          if (!src) continue

          this.tiptap.chain().focus().setImage({ src }).run()
        }
      } finally {
        // allow picking the same file again
        if (input) input.value = ''
      }
    },

    insertImageByUrl () {
      if (!this.tiptap) return
      if (!this.hasCommand('setImage')) return

      const url = window.prompt('Image URL')
      if (!url) return

      this.tiptap.chain().focus().setImage({ src: url.trim() }).run()
    },

    insertImage (val) {
      if (!this.tiptap) return
      if (!this.hasCommand('setImage')) return

      const src = (typeof val === 'string')
        ? val
        : (val && (val.url || val.src))

      if (!src || typeof src !== 'string') return

      const alt = (val && typeof val === 'object')
        ? (val.alt || val.original_name || val.name || '')
        : ''

      const title = (val && typeof val === 'object')
        ? (val.original_name || val.name || alt || '')
        : ''

      this.tiptap
        .chain()
        .focus()
        .setImage({
          src: src.trim(),
          alt,
          title
        })
        .run()
    },

    insertListIcon (val) {
      const url = typeof val === 'string' ? val : (val?.url || val?.src)
      if (!url) return
      this.tiptap.chain().focus().setBulletListIcon(url.trim()).run()
    },

    readFileAsDataURL (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '')
        reader.onerror = () => reject(reader.error || new Error('Failed to read file'))
        reader.readAsDataURL(file)
      })
    },
    setLink () {
      if (!this.hasCommand('setLink')) return

      const previousUrl = this.tiptap.getAttributes('link').href
      const url = window.prompt('URL', previousUrl || '')

      // cancelled
      if (url === null) return

      // empty => remove link
      if (url === '') {
        this.tiptap.chain().focus().extendMarkRange('link').unsetLink().run()
        return
      }

      this.tiptap
        .chain()
        .focus()
        .extendMarkRange('link')
        .setLink({
          href: url,
          target: '_blank',
          rel: 'noopener noreferrer nofollow'
        })
        .run()
    },
    unsetLink () {
      if (!this.hasCommand('unsetLink')) return
      this.tiptap.chain().focus().extendMarkRange('link').unsetLink().run()
    },
    getMarkAttrs (mark) {
      if (!this.tiptap) return {}
      try {
        return this.tiptap.getAttributes(mark) || {}
      } catch (e) {
        return {}
      }
    },
    getLinkAttributes (attrs = {}) {
      return {
        href: attrs.href || '',
        target: attrs.target || '_blank',
        rel: attrs.rel || 'noopener noreferrer nofollow'
      }
    },
    setLinkUrl (_cmd, link = {}) {
      if (!this.tiptap) return

      const href = (link.href || '').trim()

      // Empty => remove link
      if (!href) {
        this.tiptap.chain().focus().extendMarkRange('link').unsetLink().run()
        this.linkMenuIsActive = false
        return
      }

      this.tiptap
        .chain()
        .focus()
        .extendMarkRange('link')
        .setLink({
          href,
          target: link.target || '_blank',
          rel: link.rel || 'noopener noreferrer nofollow'
        })
        .run()

      this.linkMenuIsActive = false
    },
    deleteLinkUrl () {
      if (!this.tiptap) return
      this.tiptap.chain().focus().extendMarkRange('link').unsetLink().run()
      this.linkAttrs = { href: '', target: '_blank', rel: 'noopener noreferrer nofollow' }
      this.linkMenuIsActive = false
    },
    applyTag (val) {
      if (this.initEditor) return
      if (!this.tiptap) return

      const chain = this.tiptap.chain().focus()

      if (val === 'p') {
        if (this.hasCommand('setParagraph')) {
          chain.setParagraph().run()
        }
        return
      }

      const match = /^h([1-6])$/.exec(val)
      if (!match) return

      const level = Number(match[1])

      if (this.hasCommand('setHeading')) {
        chain.setHeading({ level }).run()
        return
      }

      if (this.hasCommand('toggleHeading')) {
        chain.toggleHeading({ level }).run()
      }
    },
    applyFontFamily (val) {
      if (!val) return this.unsetFontFamily()
      if (this.initEditor) return
      if (!this.tiptap) return

      if (!this.selectedMark) {
        this.fontFamily = val
        this.addSidRules([[this.sid, ['font-family', val]]])
      }

      if (this.hasCommand('setFontFamily')) {
        this.tiptap.chain().focus().setFontFamily(val).run()
        return
      }

      // Fallback: apply via textStyle mark
      if (this.hasCommand('setMark')) {
        this.tiptap.chain().focus().setMark('textStyle', { fontFamily: val }).run()
      }
    },
    unsetFontFamily () {
      if (!this.tiptap) return

      if (!this.selectedMark) {
        this.addSidRules([[this.sid, ['font-family', '']]])
      }

      if (this.hasCommand('unsetFontFamily')) {
        this.tiptap.chain().focus().unsetFontFamily().run()
        return
      }
      if (this.hasCommand('setMark')) {
        this.tiptap.chain().focus().unsetMark('textStyle').run()
      }
    },
    applyFontWeight (val) {
      if (!val) return this.unsetFontWeight()
      if (this.initEditor) return
      if (!this.tiptap) return

      const { empty, from, to } = this.tiptap.state.selection
      const hasRangeSelection = !empty && from !== to

      if (!hasRangeSelection) {
        this.fontWeight = val
        this.addSidRules([[this.sid, ['font-weight', val]]])
      }

      if (this.hasCommand('setFontWeight')) {
        this.tiptap.chain().focus().setFontWeight(val).run()
        return
      }

      if (this.hasCommand('setMark')) {
        this.tiptap.chain().focus().setMark('textStyle', { fontWeight: val }).run()
      }
    },
    unsetFontWeight () {
      if (!this.tiptap) return

      if (!this.selectedMark) {
        this.addSidRules([[this.sid, ['font-weight', '']]])
      }

      if (this.hasCommand('unsetFontWeight')) {
        this.tiptap.chain().focus().unsetFontWeight().run()
        return
      }
      if (this.hasCommand('setMark')) {
        this.tiptap.chain().focus().unsetMark('textStyle').run()
      }
    },
    applyFontSizeUnit (val) {
      this.fontSizeUnit = val
      if (val === 'rem') {
        this.applyFontSize(1)
      } else {
        this.applyFontSize(16)
      }
    },
    applyFontSize (val) {
      if (!val) return this.unsetFontSize()
      if (this.initEditor) return
      if (!this.tiptap) return

      const unit = this.fontSizeUnit
      const responsiveOpts = { breakpoint: this.getResponsiveBreakpoint() }

      this.syncResponsiveBreakpoint(responsiveOpts.breakpoint)

      if (!this.selectedMark) {
        this.fontSize = val
        this.addSidRules([[this.sid, ['font-size', `${val}${unit}`]]])
      }

      if (this.hasCommand('setFontSize')) {
        this.tiptap.chain().focus().setFontSize(`${val}${unit}`, responsiveOpts).run()
        return
      }

      if (this.hasCommand('setMark')) {
        this.tiptap.chain().focus().setMark('textStyle', { fontSize: `${val}${unit}` }).run()
      }
    },
    unsetFontSize () {
      if (!this.tiptap) return

      const responsiveOpts = { breakpoint: this.getResponsiveBreakpoint() }
      this.syncResponsiveBreakpoint(responsiveOpts.breakpoint)

      if (!this.selectedMark) {
        this.addSidRules([[this.sid, ['font-size', '']]])
      }

      if (this.hasCommand('unsetFontSize')) {
        this.tiptap.chain().focus().unsetFontSize(responsiveOpts).run()
        return
      }
      if (this.hasCommand('setMark')) {
        this.tiptap.chain().focus().unsetMark('textStyle').run()
      }
    },
    applyLetterSpacingUnit (val) {
      this.letterSpacingUnit = val
      // Keep 0 as a valid value (means “normal” spacing)
      this.applyLetterSpacing(0)
    },
    applyLetterSpacing (val) {
      if (val === '' || val === null || typeof val === 'undefined') return this.unsetLetterSpacing()
      if (this.initEditor) return
      if (!this.tiptap) return

      const unit = this.letterSpacingUnit

      if (!this.selectedMark) {
        this.letterSpacing = val
        this.addSidRules([[this.sid, ['letter-spacing', `${val}${unit}`]]])
      }

      if (this.hasCommand('setLetterSpacing')) {
        this.tiptap.chain().focus().setLetterSpacing(`${val}${unit}`).run()
        return
      }

      if (this.hasCommand('setMark')) {
        this.tiptap.chain().focus().setMark('textStyle', { letterSpacing: `${val}${unit}` }).run()
      }
    },
    unsetLetterSpacing () {
      if (!this.tiptap) return

      if (!this.selectedMark) {
        this.addSidRules([[this.sid, ['letter-spacing', '']]])
      }

      if (this.hasCommand('unsetLetterSpacing')) {
        this.tiptap.chain().focus().unsetLetterSpacing().run()
        return
      }
      if (this.hasCommand('setMark')) {
        this.tiptap.chain().focus().unsetMark('textStyle').run()
      }
    },
    applyLineHeightUnit (val) {
      this.lineHeightUnit = val
      if (val === 'em') {
        this.applyLineHeight(1.3)
      } else if (val === '%') {
        this.applyLineHeight(130)
      } else {
        this.applyLineHeight(24)
      }
    },
    applyLineHeight (val) {
      if (!val) return this.unsetLineHeight()
      if (this.initEditor) return
      if (!this.tiptap) return

      const unit = this.lineHeightUnit

      if (!this.selectedMark) {
        this.lineHeight = val
        this.addSidRules([[this.sid, ['line-height', `${val}${unit}`]]])
      }

      if (this.hasCommand('setLineHeight')) {
        this.tiptap.chain().focus().setLineHeight(`${val}${unit}`).run()
        return
      }

      if (this.hasCommand('setResponsiveMarkStyle')) {
        this.tiptap.chain().focus().setResponsiveMarkStyle('line-height', `${val}${unit}`, { markType: 'textStyle' }).run()
        return
      }

      if (this.hasCommand('setMark')) {
        this.tiptap.chain().focus().setMark('textStyle', { lineHeight: `${val}${unit}` }).run()
      }
    },
    unsetLineHeight () {
      if (!this.tiptap) return

      if (!this.selectedMark) {
        this.addSidRules([[this.sid, ['line-height', '']]])
      }

      if (this.hasCommand('unsetLineHeight')) {
        this.tiptap.chain().focus().unsetLineHeight().run()
        return
      }

      if (this.hasCommand('unsetResponsiveMarkStyle')) {
        this.tiptap.chain().focus().unsetResponsiveMarkStyle('line-height', { markType: 'textStyle' }).run()
        return
      }

      if (this.hasCommand('setMark')) {
        this.tiptap.chain().focus().unsetMark('textStyle').run()
      }
    },
    applyTextColorType (val) {
      this.colorType.backgroundType = val
      if (val === 'gradient') {
        this.unsetTextColor()
        this.applyTextColor(this.backgroundGradient)
      } else {
        this.unsetTextColor()
        this.applyTextColor('#000000')
      }
    },
    applyBgColorType (val) {
      this.bgColorType.backgroundType = val
      if (val === 'gradient') {
        this.applyBgColor(this.bgBackgroundGradient)
      } else {
        // Switching from gradient to fill — clear gradient and apply solid color
        if (this.tiptap && this.hasCommand('unsetBgGradientColor')) {
          this.tiptap.chain().focus().unsetBgGradientColor().run()
        }
        this.applyBgColor('#ffffff')
      }
    },
    applyTextColor (val) {
      const hex8ToRgba = (hex) => {
        if (typeof hex !== 'string') return ''
        const h = hex.trim()
        const m = /^#([0-9a-fA-F]{6})([0-9a-fA-F]{2})?$/.exec(h)
        if (!m) return ''

        const rgbHex = m[1]
        const aHex = m[2]

        const r = parseInt(rgbHex.slice(0, 2), 16)
        const g = parseInt(rgbHex.slice(2, 4), 16)
        const b = parseInt(rgbHex.slice(4, 6), 16)

        if (!aHex) {
          return `rgb(${r}, ${g}, ${b})`
        }

        const a = parseInt(aHex, 16) / 255
        return `rgba(${r}, ${g}, ${b}, ${Number(a.toFixed(3))})`
      }

      const normalizeColorString = (c) => {
        if (!c) return ''
        if (typeof c !== 'string') return ''
        if (/^#[0-9a-fA-F]{8}$/.test(c)) return hex8ToRgba(c)
        return c
      }

      const toCssColor = (input) => {
        if (!input) return ''
        if (typeof input === 'string') return normalizeColorString(input)

        const rgba = input.rgba || input
        if (
          rgba &&
          typeof rgba === 'object' &&
          typeof rgba.r === 'number' &&
          typeof rgba.g === 'number' &&
          typeof rgba.b === 'number'
        ) {
          const a = typeof rgba.a === 'number' ? rgba.a : 1
          return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${a})`
        }

        if (typeof input.hexa === 'string') return normalizeColorString(input.hexa)
        if (typeof input.hex === 'string') return normalizeColorString(input.hex)

        return ''
      }

      const toCssGradient = (input) => {
        if (!input || typeof input !== 'object') return null

        const cfg = (input.backgroundGradient && typeof input.backgroundGradient === 'object' && !Array.isArray(input.backgroundGradient))
          ? input.backgroundGradient
          : input

        const stops = Array.isArray(cfg.backgroundGradient)
          ? cfg.backgroundGradient
          : (cfg.backgroundGradient && Array.isArray(cfg.backgroundGradient.backgroundGradient)
            ? cfg.backgroundGradient.backgroundGradient
            : null)

        if (!Array.isArray(stops) || stops.length === 0) return null

        const directionRaw = cfg.gradientDirection ?? cfg.direction ?? cfg.angle ?? cfg.deg ?? cfg.rotation

        const directionCss = typeof directionRaw === 'number'
          ? `${directionRaw}deg`
          : (typeof directionRaw === 'string' && directionRaw.trim() ? directionRaw.trim() : '90deg')

        const parts = stops
          .filter(s => s && typeof s === 'object' && s.color)
          .map((s) => {
            const color = normalizeColorString(s.color)
            const pos = (typeof s.position === 'number') ? `${s.position}%` : ''
            return pos ? `${color} ${pos}` : `${color}`
          })

        if (parts.length === 0) return null

        return {
          css: `linear-gradient(${directionCss}, ${parts.join(', ')})`,
          direction: directionRaw
        }
      }

      const gradient = toCssGradient(val)
      const cssGradient = gradient && gradient.css
      const gradientDirection = gradient && gradient.direction

      if (cssGradient) {
        if (!this.tiptap) return

        if (!this.selectedMark) {
          this.addSidRules([
            [`${this.sid} .ProseMirror`, ['color', 'transparent']],
            [`${this.sid} .ProseMirror`, ['background-image', cssGradient]],
            [`${this.sid} .ProseMirror`, ['-webkit-background-clip', 'text']],
            [`${this.sid} .ProseMirror`, ['background-clip', 'text']],
            [`${this.sid} .ProseMirror`, ['-webkit-text-fill-color', 'transparent']]
          ])
        }

        if (this.hasCommand('setGradientColor')) {
          const chain = this.tiptap.chain().focus().setGradientColor(cssGradient)

          if (this.hasCommand('setGradientDirection') && (gradientDirection !== null && typeof gradientDirection !== 'undefined')) {
            chain.setGradientDirection(gradientDirection)
          }

          chain.run()
          return
        }

        if (this.hasCommand('setMark')) {
          const payload = { gradientColor: cssGradient }
          if (gradientDirection !== null && typeof gradientDirection !== 'undefined') payload.gradientDirection = gradientDirection
          this.tiptap.chain().focus().setMark('textStyle', payload).run()
        }

        return
      }

      const cssColor = toCssColor(val)
      if (!cssColor) return this.unsetTextColor()
      if (!this.tiptap) return

      if (!this.selectedMark) {
        this.addSidRules([[this.sid, ['color', cssColor]]])
      }

      if (this.hasCommand('setColor')) {
        this.tiptap.chain().focus().setColor(cssColor).run()
        return
      }

      if (this.hasCommand('setMark')) {
        this.tiptap.chain().focus().setMark('textStyle', { color: cssColor }).run()
      }
    },
    unsetTextColor () {
      if (!this.tiptap) return

      if (!this.selectedMark) {
        this.addSidRules([[this.sid, ['color', '']]])
        this.addSidRules([
          [`${this.sid} .ProseMirror`, ['color', '']],
          [`${this.sid} .ProseMirror`, ['background-image', '']],
          [`${this.sid} .ProseMirror`, ['-webkit-background-clip', '']],
          [`${this.sid} .ProseMirror`, ['background-clip', '']],
          [`${this.sid} .ProseMirror`, ['-webkit-text-fill-color', '']]
        ])
      }

      if (this.hasCommand('unsetGradientColor')) {
        this.tiptap.chain().focus().unsetGradientColor().run()
      }

      if (this.hasCommand('unsetColor')) {
        this.tiptap.chain().focus().unsetColor().run()
        return
      }

      if (this.hasCommand('setMark')) {
        this.tiptap.chain().focus().unsetMark('textStyle').run()
      }
    },
    applyBgColor (val) {
      const hex8ToRgba = (hex) => {
        if (typeof hex !== 'string') return ''
        const h = hex.trim()
        const m = /^#([0-9a-fA-F]{6})([0-9a-fA-F]{2})?$/.exec(h)
        if (!m) return ''

        const rgbHex = m[1]
        const aHex = m[2]

        const r = parseInt(rgbHex.slice(0, 2), 16)
        const g = parseInt(rgbHex.slice(2, 4), 16)
        const b = parseInt(rgbHex.slice(4, 6), 16)

        if (!aHex) {
          return `rgb(${r}, ${g}, ${b})`
        }

        const a = parseInt(aHex, 16) / 255
        return `rgba(${r}, ${g}, ${b}, ${Number(a.toFixed(3))})`
      }

      const normalizeColorString = (c) => {
        if (!c) return ''
        if (typeof c !== 'string') return ''
        if (/^#[0-9a-fA-F]{8}$/.test(c)) return hex8ToRgba(c)
        return c
      }

      const toCssColor = (input) => {
        if (!input) return ''
        if (typeof input === 'string') return normalizeColorString(input)

        const rgba = input.rgba || input
        if (
          rgba &&
            typeof rgba === 'object' &&
            typeof rgba.r === 'number' &&
            typeof rgba.g === 'number' &&
            typeof rgba.b === 'number'
        ) {
          const a = typeof rgba.a === 'number' ? rgba.a : 1
          return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${a})`
        }

        if (typeof input.hexa === 'string') return normalizeColorString(input.hexa)
        if (typeof input.hex === 'string') return normalizeColorString(input.hex)

        return ''
      }

      const toCssGradient = (input) => {
        if (!input || typeof input !== 'object') return ''

        const stops = Array.isArray(input.backgroundGradient)
          ? input.backgroundGradient
          : (input.backgroundGradient && Array.isArray(input.backgroundGradient.backgroundGradient)
            ? input.backgroundGradient.backgroundGradient
            : null)

        if (!Array.isArray(stops) || stops.length === 0) return ''

        const directionRaw = input.direction ?? input.angle ?? input.deg ?? input.rotation
        const direction = typeof directionRaw === 'number'
          ? `${directionRaw}deg`
          : (typeof directionRaw === 'string' && directionRaw.trim() ? directionRaw.trim() : '90deg')

        const parts = stops
          .filter(s => s && typeof s === 'object' && s.color)
          .map((s) => {
            const color = normalizeColorString(s.color)
            const pos = (typeof s.position === 'number') ? `${s.position}%` : ''
            return pos ? `${color} ${pos}` : `${color}`
          })

        if (parts.length === 0) return ''
        return `linear-gradient(${direction}, ${parts.join(', ')})`
      }

      const cssGradient = toCssGradient(val)
      if (cssGradient) {
        if (!this.tiptap) return

        if (!this.selectedMark) {
          this.addSidRules([
            [this.sid, ['background-image', cssGradient]]
          ])
        }

        if (this.hasCommand('setBgGradientColor')) {
          this.tiptap.chain().focus().setBgGradientColor(cssGradient).run()
          return
        }

        if (this.hasCommand('setMark')) {
          this.tiptap.chain().focus().setMark('textStyle', { bgGradientColor: cssGradient }).run()
        }

        return
      }

      const cssColor = toCssColor(val)
      if (!cssColor) return this.unsetBgColor()
      if (!this.tiptap) return

      if (!this.selectedMark) {
        this.addSidRules([[this.sid, ['background-color', cssColor]]])
      }

      if (this.hasCommand('setBackgroundColor')) {
        this.tiptap.chain().focus().setBackgroundColor(cssColor).run()
        return
      }

      if (this.hasCommand('setMark')) {
        this.tiptap.chain().focus().setMark('textStyle', { backgroundColor: cssColor }).run()
      }
    },
    unsetBgColor () {
      if (!this.tiptap) return

      const chain = this.tiptap.chain().focus()

      if (this.hasCommand('unsetBackgroundColor')) {
        chain.unsetBackgroundColor()
      }

      if (this.hasCommand('unsetBgGradientColor')) {
        chain.unsetBgGradientColor()
      }

      chain.run()
    },
    removeTextStyle () {
      if (!this.hasCommand('unsetMark')) return
      this.tiptap.chain().focus().unsetMark('textStyle').run()
    },
    clearFormatting () {
      if (!this.tiptap) return

      const chain = this.tiptap.chain().focus()
      if (this.hasCommand('unsetAllMarks')) chain.unsetAllMarks()
      if (this.hasCommand('clearNodes')) chain.clearNodes()
      chain.run()
    },
    onLinkChange (link = {}) {
      const href = (link && typeof link.href === 'object')
        ? (link.href.slug || link.href.href || link.custom_link || link.customLink || '')
        : (typeof link.href === 'string' ? link.href : (link.custom_link || link.customLink || ''))

      this.linkAttrs = {
        href,
        target: link.target || '_blank',
        rel: 'noopener noreferrer nofollow'
      }
    },
    applyLinkFromPanel () {
      if (!this.tiptap) return
      this.setLinkUrl(null, this.linkAttrs || {})
    },
    applyGlobalVariable (val) {
      setTimeout(() => this.tiptap.commands.globalVariable({variable: val}), 100)
    },
    applyGlobalVariableLink (val) {
      setTimeout(() => this.tiptap.commands.globalVariableLink({variable: val}), 100)
    },
    splitTopLevelCommas (input) {
      if (!input || typeof input !== 'string') return []
      const out = []
      let buf = ''
      let depth = 0

      for (let i = 0; i < input.length; i++) {
        const ch = input[i]
        if (ch === '(') depth++
        if (ch === ')') depth = Math.max(0, depth - 1)

        if (ch === ',' && depth === 0) {
          out.push(buf.trim())
          buf = ''
          continue
        }

        buf += ch
      }

      if (buf.trim()) out.push(buf.trim())
      return out
    },
    parseLinearGradientCss (css) {
      if (!css || typeof css !== 'string') return null
      const str = css.trim()
      if (!str.startsWith('linear-gradient(') || !str.endsWith(')')) return null

      const inner = str.slice('linear-gradient('.length, -1).trim()
      const parts = this.splitTopLevelCommas(inner)
      if (parts.length < 2) return null

      const first = parts[0]
      let gradientDirection = 90
      const degMatch = /(-?\d+(?:\.\d+)?)\s*deg/i.exec(first)
      const hasDirection = !!degMatch || /^to\s+/i.test(first)

      if (degMatch) {
        gradientDirection = Number(degMatch[1])
      }

      const stopParts = hasDirection ? parts.slice(1) : parts

      const stops = stopParts
        .map((raw) => {
          const token = String(raw || '').trim()
          if (!token) return null

          const posMatch = /(-?\d+(?:\.\d+)?)\s*%\s*$/i.exec(token)
          const position = posMatch ? Number(posMatch[1]) : null
          const color = posMatch ? token.slice(0, posMatch.index).trim() : token

          if (!color) return null

          return {
            color,
            position
          }
        })
        .filter(Boolean)

      if (!stops.length) return null

      const hasAnyPos = stops.some(s => typeof s.position === 'number')
      if (!hasAnyPos) {
        if (stops.length === 1) {
          stops[0].position = 0
        } else {
          stops.forEach((s, idx) => {
            s.position = Math.round((idx / (stops.length - 1)) * 100)
          })
        }
      } else {
        if (typeof stops[0].position !== 'number') stops[0].position = 0
        if (typeof stops[stops.length - 1].position !== 'number') stops[stops.length - 1].position = 100

        stops.forEach((s) => {
          if (typeof s.position === 'number') {
            s.position = Math.max(0, Math.min(100, s.position))
          }
        })
      }

      return {
        gradientDirection,
        backgroundGradient: stops.map(s => ({ color: s.color, position: s.position }))
      }
    },
    syncBackgroundGradientFromCss (css) {
      if (!css || typeof css !== 'string') return
      if (css === this.lastGradientCss) return

      const parsed = this.parseLinearGradientCss(css)
      if (!parsed) return

      this.lastGradientCss = css
      this.backgroundGradient = {
        gradientDirection: parsed.gradientDirection,
        backgroundGradient: parsed.backgroundGradient
      }
    },
    syncBgGradientFromCss (css) {
      if (!css || typeof css !== 'string') return
      if (css === this.lastBgGradientCss) return

      const parsed = this.parseLinearGradientCss(css)
      if (!parsed) return

      this.lastBgGradientCss = css
      this.bgBackgroundGradient = {
        gradientDirection: parsed.gradientDirection,
        backgroundGradient: parsed.backgroundGradient
      }
    }
  },
  watch: {
    resolutioner: {
      immediate: true,
      handler (bp) {
        this.syncResponsiveBreakpoint(bp)
        this.onEditorStateChange()
      }
    },
    tiptap: {
      immediate: true,
      handler (nextEditor, prevEditor) {
        if (prevEditor) this.unbindEditorEvents(prevEditor)
        if (nextEditor) this.bindEditorEvents(nextEditor)
        this.syncResponsiveBreakpoint()
        this.onEditorStateChange()
      }
    }
  },
  mounted () {
    setTimeout(() => this.initEditor = false)
  },
  beforeDestroy () {
    this.unbindEditorEvents()
  }
}
</script>
